import { render, staticRenderFns } from "./CustomerGroup.vue?vue&type=template&id=7fc7a3d6&scoped=true&"
import script from "./CustomerGroup.vue?vue&type=script&lang=js&"
export * from "./CustomerGroup.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGroup.vue?vue&type=style&index=0&id=7fc7a3d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc7a3d6",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn,QTooltip,QDialog,QCard,QCardSection,QInput,QCardActions});qInstall(component, 'directives', {ClosePopup});
